import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';

import * as UserContextSettingsActions from './user-context-settings.actions';
import { UserContextSettingsEntity } from './user-context-settings.models';

export const USER_CONTEXT_SETTINGS_FEATURE_KEY = 'userContextSettings';

export interface UserContextSettingsState
  extends EntityState<UserContextSettingsEntity> {
  selectedId?: string | number;
  loaded: boolean;
  error?: string | null;
}

export interface UserContextSettingsPartialState {
  readonly [USER_CONTEXT_SETTINGS_FEATURE_KEY]: UserContextSettingsState;
}

export const userContextSettingsAdapter: EntityAdapter<UserContextSettingsEntity> =
  createEntityAdapter<UserContextSettingsEntity>();

export const initialUserContextSettingsState: UserContextSettingsState =
  userContextSettingsAdapter.getInitialState({
    loaded: false,
  });

const reducer = createReducer(
  initialUserContextSettingsState,
  on(UserContextSettingsActions.initUserContextSettings, (state) => ({
    ...state,
    loaded: false,
    error: null,
  })),
  on(
    UserContextSettingsActions.loadUserContextSettingsSuccess,
    (state, { userContextSettings }) =>
      userContextSettingsAdapter.setAll(userContextSettings, {
        ...state,
        loaded: true,
      })
  ),
  on(
    UserContextSettingsActions.loadUserContextSettingsFailure,
    (state, { error }) => ({ ...state, error: error instanceof Error ? error.message : String(error) })
  )
);

export function userContextSettingsReducer(
  state: UserContextSettingsState | undefined,
  action: Action
) {
  return reducer(state, action);
}
